import React from 'react';
import './Copyright.css'; // Optional: add styles here

function Copyright() {
  return <div className='text'>© Aadhaar Koul 2025</div>
}

export default Copyright;
